import * as React from 'react';

const SvgNoUsers = (props) => (
  <svg
    width={200}
    height={169}
    viewBox="0 0 200 169"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_30528_10899)">
      <path
        d="M100.953 154.235C143.058 154.235 177.194 120.099 177.194 77.843C177.194 35.5874 143.058 1.45203 100.953 1.45203C58.8477 1.45203 24.7124 35.5874 24.7124 77.843C24.7124 120.099 58.8477 154.235 100.953 154.235Z"
        fill="#EEF4FE"
      />
      <path
        d="M185.916 46.4143C189.32 46.4143 192.081 43.654 192.081 40.2489C192.081 36.8439 189.32 34.0835 185.916 34.0835C182.51 34.0835 179.75 36.8439 179.75 40.2489C179.75 43.654 182.51 46.4143 185.916 46.4143Z"
        fill="#EAEEF9"
      />
      <path
        d="M194.937 22.2037C197.263 22.2037 199.148 20.3186 199.148 17.9932C199.148 15.6678 197.263 13.7827 194.937 13.7827C192.612 13.7827 190.727 15.6678 190.727 17.9932C190.727 20.3186 192.612 22.2037 194.937 22.2037Z"
        fill="#EAEEF9"
      />
      <path
        d="M19.4488 50.7752C21.7742 50.7752 23.6593 48.8901 23.6593 46.5647C23.6593 44.2392 21.7742 42.3541 19.4488 42.3541C17.1234 42.3541 15.2383 44.2392 15.2383 46.5647C15.2383 48.8901 17.1234 50.7752 19.4488 50.7752Z"
        fill="#EAEEF9"
      />
      <path
        d="M27.2688 142.354C31.5874 142.354 35.0883 138.853 35.0883 134.535C35.0883 130.216 31.5874 126.715 27.2688 126.715C22.9501 126.715 19.4492 130.216 19.4492 134.535C19.4492 138.853 22.9501 142.354 27.2688 142.354Z"
        fill="#EAEEF9"
      />
      <g filter="url(#filter0_d_30528_10899)">
        <path
          d="M171.63 47.3165H41.2539C38.3968 47.3165 36.1411 45.0609 36.1411 42.2037V12.8805C36.1411 10.0233 38.3968 7.7677 41.2539 7.7677H171.48C174.337 7.7677 176.593 10.0233 176.593 12.8805V42.2037C176.743 45.0609 174.337 47.3165 171.63 47.3165Z"
          fill="white"
        />
      </g>
      <path
        d="M67.72 27.4669C67.72 30.7752 66.2162 33.7827 63.9606 35.888C62.0057 37.6925 59.2989 38.7451 56.4418 38.7451C53.5846 38.7451 50.8779 37.6925 48.923 35.888C46.517 33.7827 45.1636 30.7752 45.1636 27.4669C45.1636 21.3015 50.2764 16.1887 56.4418 16.1887C62.6072 16.1887 67.72 21.3015 67.72 27.4669Z"
        fill="#FBCA4E"
      />
      <path
        d="M63.9604 35.8879C62.0056 37.6924 59.2988 38.7451 56.4416 38.7451C53.5845 38.7451 50.8777 37.6924 48.9229 35.8879C49.8251 35.5872 50.8777 35.1361 52.2311 34.5345C52.5319 34.3842 52.8326 34.0834 52.983 33.7827C53.1334 33.6323 53.1334 33.3315 53.1334 33.1812V30.324L52.983 30.1736C52.6823 29.8729 52.5319 29.4218 52.5319 28.9706L52.2311 28.8203C51.4792 28.9706 51.6296 28.2188 51.3289 26.715C51.3289 26.1135 51.3289 25.9631 51.6296 25.8127L51.9304 25.512C50.577 22.3541 51.1785 20.3992 52.6822 19.6473C52.2311 18.5947 52.2311 18.2939 52.2311 18.2939C52.2311 18.2939 55.2386 18.7451 56.1409 18.5947C57.4943 18.2939 59.4492 18.5947 60.201 20.3992C61.4041 20.8503 61.8552 21.6022 62.0056 22.5045C62.1559 23.8579 61.4041 25.3616 61.2537 25.8127C61.4041 25.9631 61.5544 26.1135 61.404 26.5646C61.2537 27.918 61.2537 28.8203 60.5018 28.6699L59.9003 30.0233C59.9003 30.1736 59.9003 30.1736 59.9003 30.324C59.9003 30.4744 59.9003 30.9255 59.9003 33.3315C59.9003 33.6323 60.0507 33.933 60.0507 34.0834C60.201 34.3842 60.5018 34.5345 60.6522 34.6849C62.0056 35.1361 63.0582 35.5872 63.9604 35.8879Z"
        fill="white"
      />
      <path
        d="M61.2933 25.9631C61.2933 25.6502 61.1368 25.1806 60.9802 24.8676V24.7111C60.3542 23.4589 59.102 22.9894 57.85 22.9894C54.7196 22.8329 54.4067 23.4589 53.311 22.5198C53.6241 22.9894 53.6241 23.772 53.1545 24.7111C52.8416 25.3371 52.2154 25.6502 51.5894 25.8067C50.1808 22.5198 50.8068 20.4852 52.3719 19.7027C51.9025 18.607 51.9025 18.2939 51.9025 18.2939C51.9025 18.2939 55.0327 18.7636 55.9718 18.607C57.3804 18.2939 59.4151 18.607 60.1977 20.4852C61.4498 20.9547 61.9193 21.7373 62.0758 22.6764C62.2324 23.772 61.4498 25.3371 61.2933 25.9631Z"
        fill="#282828"
      />
      <path
        d="M60.0506 34.0836V34.6851H52.9829V33.9332C53.1333 33.7829 53.1333 33.4821 53.1333 33.3317V30.4746L52.9829 30.3242V30.1738C53.1333 30.4746 53.2837 30.625 53.5844 30.9257L55.84 32.4295C56.2912 32.8806 57.0431 32.8806 57.6446 32.4295L59.7498 30.625L59.9002 30.4746C59.9002 30.625 59.9002 31.0761 59.9002 33.4821C59.7498 33.6325 59.9002 33.7829 60.0506 34.0836Z"
        fill="url(#paint0_linear_30528_10899)"
      />
      <path
        d="M104.712 24.1587H75.8402C75.0883 24.1587 74.6372 23.5572 74.6372 22.9557V19.1963C74.6372 18.4444 75.2387 17.9933 75.8402 17.9933H104.712C105.464 17.9933 105.915 18.5948 105.915 19.1963V22.9557C105.915 23.7076 105.464 24.1587 104.712 24.1587Z"
        fill="#EEF4FE"
      />
      <path
        d="M138.998 36.9406H75.8402C75.0883 36.9406 74.6372 36.3391 74.6372 35.7376V31.9782C74.6372 31.2263 75.2387 30.7751 75.8402 30.7751H138.998C139.75 30.7751 140.201 31.3766 140.201 31.9782V35.7376C140.201 36.4894 139.6 36.9406 138.998 36.9406Z"
        fill="#EEF4FE"
      />
      <g filter="url(#filter1_d_30528_10899)">
        <path
          d="M171.63 145.963H41.2539C38.3968 145.963 36.1411 143.708 36.1411 140.851V111.527C36.1411 108.67 38.3968 106.414 41.2539 106.414H171.48C174.337 106.414 176.593 108.67 176.593 111.527V140.851C176.743 143.708 174.337 145.963 171.63 145.963Z"
          fill="white"
        />
      </g>
      <path
        d="M67.72 126.114C67.72 129.422 66.2162 132.429 63.9606 134.535C62.0057 136.339 59.2989 137.392 56.4418 137.392C53.5846 137.392 50.8779 136.339 48.923 134.535C46.517 132.429 45.1636 129.422 45.1636 126.114C45.1636 119.948 50.2764 114.835 56.4418 114.835C62.6072 114.835 67.72 119.948 67.72 126.114Z"
        fill="#FF8F76"
      />
      <path
        d="M63.9604 134.535C62.0056 136.339 59.2988 137.392 56.4416 137.392C53.5845 137.392 50.8777 136.339 48.9229 134.535C49.8251 134.234 50.8777 133.783 52.2311 133.181C52.5319 133.031 52.8326 132.73 52.983 132.429C53.1334 132.279 53.1334 131.978 53.1334 131.828V128.971L52.983 128.82C52.6823 128.52 52.5319 128.068 52.5319 127.617L52.2311 127.467C51.4792 127.617 51.6296 126.865 51.3289 125.362C51.3289 124.76 51.3289 124.61 51.6296 124.459L51.9304 124.159C50.577 121.001 51.1785 119.046 52.6822 118.294C52.2311 117.241 52.2311 116.941 52.2311 116.941C52.2311 116.941 55.2386 117.392 56.1409 117.241C57.4943 116.941 59.4492 117.241 60.201 119.046C61.4041 119.497 61.8552 120.249 62.0056 121.151C62.1559 122.505 61.4041 124.008 61.2537 124.459C61.4041 124.61 61.5544 124.76 61.404 125.211C61.2537 126.565 61.2537 127.467 60.5018 127.317L59.9003 128.52C59.9003 128.67 59.9003 128.67 59.9003 128.82C59.9003 128.971 59.9003 129.422 59.9003 131.828C59.9003 132.129 60.0507 132.429 60.0507 132.58C60.201 132.881 60.5018 133.031 60.6522 133.181C62.0056 133.933 63.0582 134.234 63.9604 134.535Z"
        fill="white"
      />
      <path
        d="M61.2933 124.61C61.2933 124.297 61.1368 123.827 60.9802 123.514V123.358C60.3542 122.106 59.102 121.636 57.85 121.636C54.7196 121.48 54.4067 122.106 53.311 121.167C53.6241 121.636 53.6241 122.419 53.1545 123.358C52.8416 123.984 52.2154 124.297 51.5894 124.453C50.1808 121.167 50.8068 119.132 52.3719 118.349C51.9025 117.254 51.9025 116.941 51.9025 116.941C51.9025 116.941 55.0327 117.41 55.9718 117.254C57.3804 116.941 59.4151 117.254 60.1977 119.132C61.4498 119.601 61.9193 120.384 62.0758 121.323C62.2324 122.575 61.4498 123.984 61.2933 124.61Z"
        fill="#22252B"
      />
      <path
        d="M60.0506 132.73V133.332H52.9829V132.58C53.1333 132.429 53.1333 132.129 53.1333 131.978V129.121L52.9829 128.971V128.82C53.1333 129.121 53.2837 129.272 53.5844 129.572L55.84 131.076C56.2912 131.527 57.0431 131.527 57.6446 131.076L59.7498 129.272L59.9002 129.121C59.9002 129.272 59.9002 129.723 59.9002 132.129C59.7498 132.279 59.9002 132.58 60.0506 132.73Z"
        fill="url(#paint1_linear_30528_10899)"
      />
      <path
        d="M104.712 122.956H75.8402C75.0883 122.956 74.6372 122.354 74.6372 121.753V117.994C74.6372 117.242 75.2387 116.79 75.8402 116.79H104.712C105.464 116.79 105.915 117.392 105.915 117.994V121.753C105.915 122.354 105.464 122.956 104.712 122.956Z"
        fill="#EEF4FE"
      />
      <path
        d="M138.998 135.738H75.8402C75.0883 135.738 74.6372 135.136 74.6372 134.535V130.775C74.6372 130.024 75.2387 129.572 75.8402 129.572H138.998C139.75 129.572 140.201 130.174 140.201 130.775V134.535C140.201 135.136 139.6 135.738 138.998 135.738Z"
        fill="#EEF4FE"
      />
      <g filter="url(#filter2_d_30528_10899)">
        <path
          d="M149.524 96.6401H19.2988C16.4417 96.6401 14.186 94.3844 14.186 91.5273V62.204C14.186 59.3468 16.4417 57.0912 19.2988 57.0912H149.524C152.382 57.0912 154.638 59.3468 154.638 62.204V91.5273C154.788 94.3844 152.382 96.6401 149.524 96.6401Z"
          fill="white"
        />
      </g>
      <path
        d="M82.7573 73.4821H53.8851C53.1333 73.4821 52.6821 72.8806 52.6821 72.2791V68.5197C52.6821 67.7678 53.2836 67.3167 53.8851 67.3167H82.7573C83.5092 67.3167 83.9603 67.9182 83.9603 68.5197V72.2791C83.9603 73.0309 83.5092 73.4821 82.7573 73.4821Z"
        fill="#EEF4FE"
      />
      <path
        d="M117.043 86.4143H53.8851C53.1333 86.4143 52.6821 85.8128 52.6821 85.2113V81.4519C52.6821 80.7 53.2836 80.2489 53.8851 80.2489H116.893C117.645 80.2489 118.096 80.8504 118.096 81.4519V85.2113C118.246 85.8128 117.645 86.4143 117.043 86.4143Z"
        fill="#EEF4FE"
      />
      <path
        d="M45.9153 76.7904C45.9153 79.9483 44.5619 82.8054 42.4566 84.9107C42.3062 85.0611 42.3062 85.0611 42.1559 85.2115C40.201 87.016 37.4942 88.0686 34.6371 88.0686C31.7799 88.0686 29.2235 87.016 27.2686 85.3618C27.2686 85.3618 27.2686 85.3618 27.1183 85.3618C24.7123 83.2566 23.2085 80.2491 23.2085 76.7904C23.2085 70.625 28.3213 65.5122 34.4867 65.5122C40.8025 65.5122 45.9153 70.625 45.9153 76.7904Z"
        fill="#7FE7CE"
      />
      <path
        d="M42.4124 85.1395C41.9549 84.072 41.1924 83.1571 39.9724 82.5471C39.3624 82.2421 38.905 82.0896 38.1424 82.0896H37.685C36.6175 82.0896 36.465 81.9371 36.465 81.9371V80.1072C37.685 79.1922 38.6 77.9722 38.905 76.5997C39.6674 76.4472 40.125 75.8373 39.9724 75.0747C39.9724 74.7698 39.6674 74.4648 39.6674 74.1598C39.6674 74.0074 39.6674 73.8549 39.6674 73.7023C39.6674 73.5498 39.6674 73.5498 39.6674 73.3973C39.6674 73.2448 39.6674 73.2448 39.6674 73.0923C39.6674 72.4824 39.5149 72.0248 39.0575 71.4149C38.1424 69.7374 36.3125 68.6699 34.3301 68.6699C33.8727 68.6699 33.5675 68.6699 33.1101 68.8224C32.3477 68.9749 31.7376 69.28 31.1277 69.7374C30.9752 69.8899 30.9752 69.8899 30.8227 70.0424C30.8227 70.0424 30.8227 70.0424 30.6701 70.1949C30.0602 70.805 29.6027 71.5674 29.2978 72.3299C28.9927 73.0923 28.9927 74.0074 28.9927 74.9223C28.9927 74.9223 28.9927 74.9223 28.9927 75.0747C28.9927 75.2272 28.9927 75.2272 28.9927 75.3798C28.9927 75.3798 28.9927 75.5323 28.8402 75.5323C29.1453 75.2272 28.9927 75.6848 29.1453 75.9898C29.4503 76.7522 29.9077 76.5997 30.5176 77.0573C30.5176 77.0573 30.5176 77.0573 30.3651 77.0573L29.7552 77.2098C26.4003 78.2771 26.0954 81.7847 29.4503 82.5471C29.1453 82.6995 28.9927 82.852 28.8402 82.852C27.9253 83.6146 27.3152 84.5295 27.0103 85.4445C28.9927 87.1219 31.5851 88.1895 34.4826 88.1895C37.38 88.1895 40.125 87.122 42.1074 85.292C42.2599 85.4445 42.4124 85.292 42.4124 85.1395C42.5648 85.1395 42.5648 85.1395 42.4124 85.1395ZM32.9576 81.4795C32.8051 81.3271 32.6527 81.1746 32.6527 81.1746C32.5002 81.0221 32.3477 81.0221 32.1951 80.8696C32.1951 80.8696 32.0426 80.8696 32.0426 80.7171C31.5851 80.4122 31.1277 80.1072 30.9752 79.6496C30.9752 79.4971 31.1277 79.1922 31.4327 78.8872C31.5851 79.0397 31.7376 79.1922 31.8901 79.4971C32.0426 79.6496 32.1951 79.8021 32.3477 79.9546C32.5002 79.9546 32.6527 80.1072 32.6527 80.2597C32.6527 80.2597 32.6527 80.2597 32.8051 80.2597C32.8051 80.2597 32.8051 80.2597 32.9576 80.2597V81.4795Z"
        fill="white"
      />
      <path
        d="M37.87 82.0024C37.7196 82.6039 37.4189 83.055 37.4189 83.055L31.7046 82.1528L32.0053 80.649C32.0053 80.649 32.1557 80.649 32.1557 80.7994C32.3061 80.9497 32.4565 80.9497 32.6068 81.1001C32.7572 81.1001 32.7572 81.2505 32.9076 81.4009V80.3482C32.9076 80.3482 32.9076 80.3482 32.7572 80.3482C33.6595 80.7994 34.8625 81.1001 36.5166 80.0475V81.852C36.667 81.852 36.8174 82.0024 37.87 82.0024Z"
        fill="url(#paint2_linear_30528_10899)"
      />
      <path
        d="M36.6814 73.6152C37.7544 73.6152 38.8271 73.462 39.7467 73.1554C39.7467 73.1554 39.7467 73.0021 39.8999 72.8489C39.7467 72.3891 39.5933 71.7761 39.2868 71.163C38.3673 69.4773 36.5282 68.4045 34.5359 68.4045C34.0762 68.4045 33.6351 68.4373 33.0202 68.5906C32.2019 68.8406 31.8219 69.0605 31.628 69.1779C31.628 69.1779 31.1801 69.4791 30.8578 69.7838C30.5354 70.0885 29.785 71.163 29.4784 71.9294C29.172 72.8489 28.9247 73.6304 29.078 74.55C29.2312 74.55 29.4784 74.3814 29.6318 74.3814C30.8578 73.7685 31.7774 73.0021 32.2371 71.7761C33.4631 72.8489 34.9957 73.462 36.6814 73.6152Z"
        fill="#2D201C"
      />
      <path
        d="M31.479 79.046C31.6294 79.1964 31.7798 79.3468 31.9301 79.4971C31.7798 79.3468 31.6294 79.1964 31.479 79.046Z"
        fill="#3973F4"
      />
      <path
        d="M33.5846 84.6099C33.1334 85.2114 32.3816 85.2114 31.6297 85.2114C32.3816 84.4595 31.9304 82.2038 29.5244 82.5046C26.0658 81.9031 26.5169 78.2941 29.8252 77.2414L30.4267 77.0911C30.4267 77.0911 30.4267 77.0911 30.5771 77.2414C30.8778 77.9933 31.1786 78.4445 31.6297 79.046C30.2763 80.249 32.2312 80.5497 33.1334 81.452C33.7349 81.7527 34.3364 83.7076 33.5846 84.6099Z"
        fill="#2D201C"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_30528_10899"
        x={19.4945}
        y={0.369205}
        width={173.752}
        height={72.8421}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={9.24812} />
        <feGaussianBlur stdDeviation={8.32331} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30528_10899"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30528_10899"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_30528_10899"
        x={19.4945}
        y={99.0159}
        width={173.752}
        height={72.8421}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={9.24812} />
        <feGaussianBlur stdDeviation={8.32331} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30528_10899"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30528_10899"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_30528_10899"
        x={-2.46058}
        y={49.6927}
        width={173.752}
        height={72.8421}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={9.24812} />
        <feGaussianBlur stdDeviation={8.32331} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30528_10899"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30528_10899"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_30528_10899"
        x1={56.519}
        y1={34.7125}
        x2={56.519}
        y2={32.2272}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#E2E5EC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_30528_10899"
        x1={56.519}
        y1={133.359}
        x2={56.519}
        y2={130.874}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#E2E5EC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_30528_10899"
        x1={34.7893}
        y1={83.0734}
        x2={34.7893}
        y2={81.4165}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#E2E5EC" />
      </linearGradient>
      <clipPath id="clip0_30528_10899">
        <rect width={200} height={168.421} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNoUsers;
